import BaseError from './BaseError';

class VastParseError extends BaseError {
  constructor(message: string, fileName?: string, lineNumber?: number) {
    super('VastParseError', message, fileName, lineNumber);
  }
}

export default VastParseError;
